import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi"; // Import hamburger and close icons
import { Outlet } from "react-router-dom";
import scheduleGif from "../assets/schedule.gif";
import paymentGif from "../assets/payment.gif";
import profileGif from "../assets/profile.gif";
import logoutGif from "../assets/power.gif";
import bookingGif from "../assets/booking.gif";
import { useAuth } from '../components/AuthContext';
import { BaseUrl } from "../App";
import axios from "axios";

const StaffPanel = () => {
  const sidebarRef = useRef(null);
  const { logout } = useAuth()

  const navigate = useNavigate();
  const [Settings,setSettings] = useState({});
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [submenuVisible, setSubmenuVisible] = useState({
    appointment: false,
    service: false,
    schedule: false,
    staff: false,
    crm: false,
    payment: false,
    export: false,
    embeded: false,
    setting: false,
  });

  // Function to handle navigation
  const handleNavigation = (path) => {
    navigate(path);
    // Close sidebar on navigation for mobile and tablet
    if (isMobile || isTablet) {
      setSidebarVisible(false);
    }
  };


  const fetchSettings = async () => {
  
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/settings.php`,
        {
          action: "get_all_settings",
          api_key: "1",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.data.status === "true" && response.data.statuscode === 200) {
        const fetchedSettings = response.data.response.reduce((acc, item) => {
          if (item.option_name === "ct_company_logo") {
            acc[item.option_name] = item.postalcode; // Store postal codes as a comma-separated string
          } else {
            acc[item.option_name] = item.option_value;
          }
          return acc;
        }, {});
        console.log(fetchedSettings )
  
        setSettings((prevSettings) => ({
          ...prevSettings,
          ...fetchedSettings,
        }));  
      } else {
        throw new Error(response.data.response || "Failed to fetch settings");
      }
    } catch (error) {
      console.error(error.message);
    } 
  };
  // Call fetchSettings on component mount
  useEffect(() => {
    // const interval = setInterval(() => {
    //   fetchSettings();
    // }, 1000); // 1000ms = 1 second
    fetchSettings();
  
    // return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  // Toggle submenu visibility for each section
  const toggleSubmenu = (section) => {
    setSubmenuVisible((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleProfileClick = () => {
    navigate("/staff/staffProfile");
    // Close sidebar on navigation for mobile and tablet
    if (isMobile || isTablet) {
      setSidebarVisible(false);
    }
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    // setShowLogoutModal(false);
    // navigate("/login");

    setShowLogoutModal(false); // Close modal
    // navigate("/login"); // Redirect to login page
    logout(); // Call the logout function
    console.log('Staff logged out successfully');
    sessionStorage.removeItem('isLoggedIn'); //

    // window.location.href = '/login'; // Example: Redirect to login page
    navigate("/login"); 

  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  // Toggle sidebar function
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  useEffect(() => {
    // Check screen size on initial load and when window is resized
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 640;
      const tablet = window.innerWidth >= 640 && window.innerWidth < 1024;
      setIsMobile(mobile);
      setIsTablet(tablet);
      
      // For desktop, always show sidebar initially
      if (window.innerWidth >= 1024 && !sidebarVisible) {
        setSidebarVisible(true);
      }
      
      // For mobile and tablet, hide sidebar initially
      if ((mobile || tablet) && sidebarVisible && window.innerWidth < 1024) {
        setSidebarVisible(false);
      }
    };
    
    // Add resize event listener
    window.addEventListener('resize', checkScreenSize);
    
    // Initial check
    checkScreenSize();
    
    // Cleanup event listener
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


  const staffdb = () => {
    navigate("/staff")
  }

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      {/* Sidebar overlay for mobile and tablet - only shown when sidebar is visible */}
      {(isMobile || isTablet) && sidebarVisible && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={toggleSidebar}
        />
      )}
      
      {/* Sidebar - Full height and scrollable */}
      <div
        ref={sidebarRef}
        className={`${
          sidebarVisible ? "translate-x-0" : "-translate-x-full"
        } fixed top-0 left-0 bottom-0 w-1/2 sm:w-60 md:w-22 bg-white text-black shadow-xl z-50 transition-transform duration-300 ease-in-out flex flex-col h-full`}
      >
        {/* Sidebar Header */}
        <div 
          style={{
            backgroundColor: Settings?.ct_primary_color || "#0834e2"    
          }}
        className=" from-blue-700 to-indigo-800 p-4 flex justify-between items-center">
          <h2 
          style={{         
            color: Settings?.ct_text_color || "#ffffff",
          }}
          className="text-xl font-bold text-white cursor-pointer hover:text-gray-300" onClick={() => staffdb()}>Staff Panel</h2>
          <button
            onClick={toggleSidebar}
            className="text-white hover:text-red-300 transition-colors"
            aria-label="Close sidebar"
          >
            <FiX size={24} />
          </button>
        </div>
        
        {/* Navigation Menu - Make it scrollable */}
        <div className="flex-1 overflow-y-auto">
          <ul className="p-2">
            {/* Booking */}
            <li className="mb-2">
              <button
                onClick={() => handleNavigation("/staff/booking")}
                className=" items-center w-full  text-center p-3 rounded-lg hover:bg-indigo-100 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-indigo-100">
                    <img
                      src={bookingGif}
                      alt="booking"
                      className="w-8 h-8 transition-all duration-300 transform hover:scale-110"
                    />
                  </div>
                  <span className="text-base font-medium text-gray-800">Booking</span>
                </div>
              </button>
            </li>

            {/* Schedule */}
            <li className="mb-2">
              <button
                onClick={() => handleNavigation("/staff/schedule_s")}
                className="flex items-center w-full text-left p-3 rounded-lg hover:bg-indigo-100 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-indigo-100">
                    <img
                      src={scheduleGif}
                      alt="Schedule"
                      className="w-8 h-8 transition-all duration-300 transform hover:scale-110"
                    />
                  </div>
                  <span className="text-base font-medium text-gray-800">Schedule</span>
                </div>
              </button>
            </li>

            {/* Payment */}
            <li className="mb-2">
              <button
                onClick={() => handleNavigation("/staff/payment_s")}
                className="flex items-center w-full text-left p-3 rounded-lg hover:bg-indigo-100 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-indigo-100">
                    <img
                      src={paymentGif}
                      alt="Payment"
                      className="w-8 h-8 transition-all duration-300 transform hover:scale-110"
                    />
                  </div>
                  <span className="text-base font-medium text-gray-800">Payment</span>
                </div>
              </button>
            </li>
            
            {/* Profile */}
            <li className="mb-2">
              <button
                onClick={handleProfileClick}
                className="flex items-center w-full text-left p-3 rounded-lg hover:bg-indigo-100 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-indigo-100">
                    <img
                      src={profileGif}
                      alt="Profile"
                      className="w-8 h-8 transition-all duration-300 transform hover:scale-110"
                    />
                  </div>
                  <span className="text-base font-medium text-gray-800">Profile</span>
                </div>
              </button>
            </li>
            
            {/* Logout */}
            <li className="mb-2">
              <button
                onClick={handleLogoutClick}
                className="flex items-center w-full text-left p-3 rounded-lg hover:bg-red-100 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
                    <img
                      src={logoutGif}
                      alt="logout"
                      className="w-8 h-8 transition-all duration-300 transform hover:scale-110"
                    />
                  </div>
                  <span className="text-base font-medium text-gray-800">Logout</span>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Main Layout */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${!isMobile && !isTablet && sidebarVisible ? 'ml-60 md:ml-60' : ''}`}>
        {/* Header */}
        <header 
         style={{       
          backgroundColor: Settings?.ct_primary_color || "#0834e2",       
          color: Settings?.ct_text_color || "#ffffff",
        }}
        className=" from-indigo-800 to-blue-600 text-white p-5  flex justify-between items-center shadow-lg">
          {/* Menu toggle button */}
          <button 
            onClick={toggleSidebar}
            className="flex items-center text-white hover:text-indigo-200 transition-colors focus:outline-none"
            style={{color: Settings?.ct_text_color || "#ffffff"}}
            aria-label="Toggle sidebar"
          >
        {sidebarVisible ? "" :<FiMenu size={24} />}
            {/* <span className="ml-2 text-lg font-medium">Menu</span> */}
          </button>
          
          {/* <h1 */}
            {/* // onClick={() => navigate("/my-booking")}
          //   className="text-xl font-bold cursor-pointer"
          // >
          //   My Company Name
          {/* // </h1> */}
<h1> {Settings.ct_company_name ? Settings.ct_company_name : "  My Company Name"}

<span 
// style={{
         
//   color: Settings?.ct_text_color || "#ffffff",
// }}
className="ml-2 px-2 py-1 bg-white text-indigo-800 text-xs rounded-full"> Staff</span> 
   </h1>       
          
          <div className="flex items-center">
            {/* You can add notification icons here */}
          </div>
        </header>

        {/* Logout Modal */}
        {showLogoutModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-sm">
              <h3 className="text-xl font-bold text-center text-gray-800 mb-4">
                Confirm Logout
              </h3>
              <p className="text-gray-600 text-center mb-6">
                Are you sure you want to log out of your account?
              </p>
              <div className="flex justify-center space-x-4">
                <button
                  onClick={handleLogoutCancel}
                  className="px-5 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogoutConfirm}
                  className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Content Section */}
        <main className="flex-1  overflow-auto">
          <div className="">
            <Outlet />
          </div>
        </main>
        
        {/* Footer */}
        
      </div>
    </div>
  );
};

export default StaffPanel;

// import React, { useRef,useEffect,useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FiMenu,  FiX } from "react-icons/fi"; // Import hamburger and right-chevron icon
// import { Outlet } from "react-router-dom";
// import { FaBell, FaUser } from "react-icons/fa";
// import { FaPowerOff } from "react-icons/fa6";
// import scheduleGif from "../assets/schedule.gif";
// import paymentGif from "../assets/payment.gif";
// import profileGif from "../assets/profile.gif";
// import logoutGif from "../assets/power.gif";
// import bookingGif from "../assets/booking.gif";
// const StaffPanel = () => {
//       const sidebarRef = useRef(null);  
  
//   const navigate = useNavigate(); // Initialize navigate hook
//   const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar starts as hidden
//   const [notificationSidebarVisible, setNotificationSidebarVisible] =
//     useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [submenuVisible, setSubmenuVisible] = useState({
//     appointment: false,
//     service: false,
//     schedule: false,
//     staff: false,
//     crm: false,
//     payment: false,
//     export: false,
//     embeded: false,
//     setting: false,
//   }); // State for submenu visibility

//  // Example:  Accessing the sidebar's DOM node
//   const handleClickOutside = (event) => {
//     if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         // Click was outside the sidebar
//         setSidebarVisible(false);
        
//     }
//   };
  
//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//         document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // Function to handle navigation
//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   // Toggle Sidebar visibility
//   const toggleSidebar = () => {
//     setSidebarVisible(!sidebarVisible);
//   };

//   // Toggle Notification Sidebar visibility
//   const toggleNotificationSidebar = () => {
//     setNotificationSidebarVisible(!notificationSidebarVisible);
//   };

//   // Toggle submenu visibility for each section
//   const toggleSubmenu = (section) => {
//     setSubmenuVisible((prevState) => ({
//       ...prevState,
//       [section]: !prevState[section],
//     }));
//   };
//   const handleProfileClick = () => {
//     // Navigate to the admin profile page
//     navigate("staffProfile");
//   };
//   const handleLogoutClick = () => {
//     // Show the confirmation modal when logout icon is clicked
//     setShowLogoutModal(true);
//   };
//   const handleLogoutConfirm = () => {
//     // Navigate to the login page when user confirms logout
//     setShowLogoutModal(false); // Close modal
//     navigate("/"); // Redirect to login page
//   };

//   const handleLogoutCancel = () => {
//     // Close the modal without logging out
//     setShowLogoutModal(false);
//   };
//   return (
//     <div className="flex min-h-screen">
//       {/* Sidebar */}
//       <div
//       ref={sidebarRef}

//         className={`${
//           sidebarVisible ? "block" : "hidden"
//         } fixed top-0 left-0 w-64 h-full bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 rounded-lg z-50 transition-all duration-300`}
//         style={{ maxHeight: "100vh", overflowY: "auto" }} // Allow scrolling within the sidebar
//       >
//         {/* Close Icon */}
//         <button
//           onClick={() => setSidebarVisible(false)}
//           className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//         >
//           <FiX />
//         </button>
//         <h2 className="text-2xl font-medium text-center mb-8">Staff Panel</h2>
//         <ul>
//           {/* {booking} */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/booking")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={bookingGif}
//                   alt="booking"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Booking</span>
//               </div>
//             </button>
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/schedule_s")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={scheduleGif}
//                   alt="Schedule"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Schedule</span>
//               </div>
//             </button>
//           </li>

//           {/* Payment */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/payment_s")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={paymentGif}
//                   alt="Payment"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Payment</span>
//               </div>
//             </button>
//           </li>
//           {/* profile*/}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/staffProfile")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={profileGif}
//                   alt="Profile"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Profile</span>
//               </div>
//             </button>
//           </li>
//           {/* {logout} */}
//           <li className="mb-1">
//             <button
//               onClick={handleLogoutClick}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={logoutGif}
//                   alt="logout"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Logout</span>
//               </div>
//             </button>
//           </li>
//         </ul>
//       </div>

//       {/* Main Layout */}
//       <div className="flex-1 flex flex-col relative">
//         {/* Header */}
//         <header className="bg-blue-800 text-white p-4 flex justify-between items-center">
//           <button onClick={toggleSidebar} className="text-white text-2xl">
//             <FiMenu />
//           </button>
//           <h1
//             onClick={() => navigate("/my-booking")}
//             className="text-2xl font-medium cursor-pointer"
//           >
//             My Company Name | Staff
//           </h1>
//           <div className="flex items-center space-x-4">
                    
//           </div>
//         </header>

//         {/* Logout Modal */}
//         {showLogoutModal && (
//           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 sm:w-1/3 max-w-sm">
//               <p className="text-lg font-medium text-gray-800 mb-4">
//                 Are you sure you want to log out?
//               </p>
//               <div className="flex justify-center space-x-4 mt-4">
//                 <button
//                   onClick={handleLogoutConfirm}
//                   className="px-4 py-2 bg-green-500 text-white rounded-md"
//                 >
//                   Yes
//                 </button>
//                 <button
//                   onClick={handleLogoutCancel}
//                   className="px-4 py-2 bg-red-500 text-white rounded-md"
//                 >
//                   No
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
       
      

//         {/* Content Section */}
//         <main className=" flex-1 p-8">
//           <Outlet /> {/* This renders the matching route content */}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default StaffPanel;



































// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FiMenu,  FiX } from "react-icons/fi"; // Import hamburger and right-chevron icon
// import { Outlet } from "react-router-dom";
// import { FaBell, FaUser } from "react-icons/fa";
// import { FaPowerOff } from "react-icons/fa6";
// import scheduleGif from "../assets/schedule.gif";
// import paymentGif from "../assets/payment.gif";
// import profileGif from "../assets/profile.gif";
// import logoutGif from "../assets/power.gif";
// import bookingGif from "../assets/booking.gif";
// const StaffPanel = () => {
//   const navigate = useNavigate(); // Initialize navigate hook
//   const [sidebarVisible, setSidebarVisible] = useState(false); // Sidebar starts as hidden
//   const [notificationSidebarVisible, setNotificationSidebarVisible] =
//     useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [submenuVisible, setSubmenuVisible] = useState({
//     appointment: false,
//     service: false,
//     schedule: false,
//     staff: false,
//     crm: false,
//     payment: false,
//     export: false,
//     embeded: false,
//     setting: false,
//   }); // State for submenu visibility
//   // Function to handle navigation
//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   // Toggle Sidebar visibility
//   const toggleSidebar = () => {
//     setSidebarVisible(!sidebarVisible);
//   };

//   // Toggle Notification Sidebar visibility
//   const toggleNotificationSidebar = () => {
//     setNotificationSidebarVisible(!notificationSidebarVisible);
//   };

//   // Toggle submenu visibility for each section
//   const toggleSubmenu = (section) => {
//     setSubmenuVisible((prevState) => ({
//       ...prevState,
//       [section]: !prevState[section],
//     }));
//   };
//   const handleProfileClick = () => {
//     // Navigate to the admin profile page
//     navigate("staffProfile");
//   };
//   const handleLogoutClick = () => {
//     // Show the confirmation modal when logout icon is clicked
//     setShowLogoutModal(true);
//   };
//   const handleLogoutConfirm = () => {
//     // Navigate to the login page when user confirms logout
//     setShowLogoutModal(false); // Close modal
//     navigate("/"); // Redirect to login page
//   };

//   const handleLogoutCancel = () => {
//     // Close the modal without logging out
//     setShowLogoutModal(false);
//   };
//   return (
//     <div className="flex min-h-screen">
//       {/* Sidebar */}
//       <div
//         className={`${
//           sidebarVisible ? "block" : "hidden"
//         } fixed top-0 left-0 w-64 h-full bg-white text-black p-6 shadow-lg border-e-2 border-blue-800 rounded-lg z-50 transition-all duration-300`}
//         style={{ maxHeight: "100vh", overflowY: "auto" }} // Allow scrolling within the sidebar
//       >
//         {/* Close Icon */}
//         <button
//           onClick={() => setSidebarVisible(false)}
//           className="absolute top-4 right-4 text-black text-lg hover:text-red-500 transition-all duration-300"
//         >
//           <FiX />
//         </button>
//         <h2 className="text-2xl font-medium text-center mb-8">Staff Panel</h2>
//         <ul>
//           {/* {booking} */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/booking")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={bookingGif}
//                   alt="booking"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Booking</span>
//               </div>
//             </button>
//           </li>

//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/schedule_s")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={scheduleGif}
//                   alt="Schedule"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Schedule</span>
//               </div>
//             </button>
//           </li>

//           {/* Payment */}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/payment_s")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={paymentGif}
//                   alt="Payment"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Payment</span>
//               </div>
//             </button>
//           </li>
//           {/* profile*/}
//           <li className="mb-1">
//             <button
//               onClick={() => handleNavigation("/staff/staffProfile")}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={profileGif}
//                   alt="Profile"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Profile</span>
//               </div>
//             </button>
//           </li>
//           {/* {logout} */}
//           <li className="mb-1">
//             <button
//               onClick={handleLogoutClick}
//               className="flex items-center justify-between w-full text-black hover:bg-blue-400 rounded-lg p-2 transition-all duration-300"
//             >
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={logoutGif}
//                   alt="logout"
//                   className="w-12 h-12 transition-all duration-300 transform hover:scale-110 hover:rotate-180"
//                 />
//                 <span className="text-lg font-medium">Logout</span>
//               </div>
//             </button>
//           </li>
//         </ul>
//       </div>

//       {/* Main Layout */}
//       <div className="flex-1 flex flex-col relative">
//         {/* Header */}
//         <header className="bg-blue-800 text-white p-4 flex justify-between items-center">
//           <button onClick={toggleSidebar} className="text-white text-2xl">
//             <FiMenu />
//           </button>
//           <h1
//             onClick={() => navigate("/my-booking")}
//             className="text-2xl font-medium cursor-pointer"
//           >
//             My Company Name | Staff
//           </h1>
//           <div className="flex items-center space-x-4">
                    
//           </div>
//         </header>

//         {/* Logout Modal */}
//         {showLogoutModal && (
//           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 sm:w-1/3 max-w-sm">
//               <p className="text-lg font-medium text-gray-800 mb-4">
//                 Are you sure you want to log out?
//               </p>
//               <div className="flex justify-center space-x-4 mt-4">
//                 <button
//                   onClick={handleLogoutConfirm}
//                   className="px-4 py-2 bg-green-500 text-white rounded-md"
//                 >
//                   Yes
//                 </button>
//                 <button
//                   onClick={handleLogoutCancel}
//                   className="px-4 py-2 bg-red-500 text-white rounded-md"
//                 >
//                   No
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
       
      

//         {/* Content Section */}
//         <main className=" flex-1 p-8">
//           <Outlet /> {/* This renders the matching route content */}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default StaffPanel;
